
import { Prop, Vue, Component } from 'vue-property-decorator'

import strings from '@/assets/strings.json'
import { ProductDetail } from '@/models/ProductDetail'
import LazyImage from '@/components/LazyImage.vue'

@Component({
  components: {
    LazyImage
  }
})
export default class Summary extends Vue {
  @Prop() private products!: ProductDetail[];
  @Prop() private inEcommerce!: boolean;
  @Prop() private onProductRemove!: Function;

  @Prop() private onPdfCreate!: Function;
  @Prop() private onAddToCart!: Function;

  private summaryStrings = strings.Step3.Summary

  get total (): string {
    const totalPrice = this.products.map((product: ProductDetail) => {
      return product.price
    })
      .reduce((accumulator, currentValue) => {
        return accumulator + currentValue
      }, 0)

    return totalPrice.toFixed(2) + ' ' + this.products[0].currency
  }

  removeProduct (productIndex: number) {
    this.onProductRemove(productIndex)
  }

  createPdf () {
    this.onPdfCreate(this.total)
  }

  addToCart () {
    this.onAddToCart()
  }
}
